import LoanOverviewEs from "./es";
import LoanOverviewSe from "./common";
import { Country } from "../../../types/common";

const COMMON_COUNTRIES = [Country.SE, Country.NO, Country.FI];

export const LoanOverview = (flow: any) => {
  const country = flow?.caseData?.data?.country || ""
  if (COMMON_COUNTRIES.includes(country)) {
    return LoanOverviewSe(flow);
  }
    return LoanOverviewEs(flow);
}